module.exports = __webpack_public_path__ + "img/android-download.89458a8a.png";